module.exports = __webpack_public_path__ + "static/media/target.4e5e68e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/extension-icons/target.png
// module id = 990
// module chunks = 0